import { createEndpoint, Type } from '../../models/europrisme';
import {
  GET_IMAGEB64_REJECTED,
  GET_IMAGEB64_REQUESTED,
  GET_IMAGEB64_RESOLVED,
  GET_RESOURCEB64_REJECTED,
  GET_RESOURCEB64_REQUESTED,
  GET_RESOURCEB64_RESOLVED,
  POST_RESOURCEB64_REJECTED,
  POST_RESOURCEB64_REQUESTED,
  POST_RESOURCEB64_RESOLVED,
} from '../types';

// ==================================================================
// Fetch Resource B64
// ==================================================================
export const fetchResourceB64Requested = params => ({
  type: GET_RESOURCEB64_REQUESTED,
  payload: { params },
});

export const fetchResourceB64Rejected = (error, params) => ({
  type: GET_RESOURCEB64_REJECTED,
  payload: { error, params },
});

export const fetchResourceB64Resolved = (data, params) => ({
  type: GET_RESOURCEB64_RESOLVED,
  payload: { data, params },
});

export const fetchResourceB64 = createEndpoint(
  Type.GET,
  'getResourceB64',
  {
    sResourceCategory: 'IMG',
    sParentEntityType: '',
    sParentEntityValue: '',
    kIDUser: 1,
  },
  {
    request: fetchResourceB64Requested,
    resolve: fetchResourceB64Resolved,
    reject: fetchResourceB64Rejected,
  },
);

// ==================================================================
// Upload Resource B64
// ==================================================================
export const uploadResourceB64Requested = () => ({
  type: POST_RESOURCEB64_REQUESTED,
});

export const uploadResourceB64Rejected = error => ({
  type: POST_RESOURCEB64_REJECTED,
  payload: { error },
});

export const uploadResourceB64Resolved = () => ({
  type: POST_RESOURCEB64_RESOLVED,
});

export const uploadResourceB64 = createEndpoint(
  Type.POST,
  'insertResourceB64',
  {
    sResourceCategory: 'IMG',
    sResourceTypeExtension: 'PNG',
    sParentEntityType: '',
    sParentEntityValue: '',
    sB64Resource: '',
    kIDUser: 1,
  },
  {
    request: uploadResourceB64Requested,
    resolve: uploadResourceB64Resolved,
    reject: uploadResourceB64Rejected,
  },
);

// ==================================================================
// Fetch Image B64
// ==================================================================
export const fetchImageB64Requested = params => ({
  type: GET_IMAGEB64_REQUESTED,
  payload: { params },
});

export const fetchImageB64Rejected = (error, params) => ({
  type: GET_IMAGEB64_REJECTED,
  payload: { error, params },
});

export const fetchImageB64Resolved = (data, params) => ({
  type: GET_IMAGEB64_RESOLVED,
  payload: { data, params },
});

export const fetchImageB64 = createEndpoint(
  Type.GET,
  'getImageB64',
  {
    sLocalPath: '',
  },
  {
    request: fetchImageB64Requested,
    resolve: fetchImageB64Resolved,
    reject: fetchImageB64Rejected,
  },
);

export const IMAGES_ACTIONS = {
  fetchResourceB64,
  uploadResourceB64,
  fetchImageB64,
};
